/**
 * Adds text next to Video modal icon
 *
 * @since   1.0.0
 * @package veristream
 */
(function($) {
	var $carousel = $('.slider-testimonials .elementor-widget-wrap');

	$(window).load(function(){
		$carousel.flickity({
		  // options
		  wrapAround: true,
		  cellSelector: '.elementor-widget-image-box',
		  imagesLoaded: true,
		  adaptiveHeight: $(window).width() <= 1024, // make slides the same height on > large bp
		});

	})
})(jQuery);
